module.exports = __webpack_public_path__ + "static/media/prospero-aerial-1-large.0830daee.jpg";